import { useChannelTalk } from '@repo/channel-talk';
import { useUserEventLogger } from '@repo/tracking-service';
import cn from 'clsx';
import Link from 'next/link';
import { ReactNode } from 'react';

import s from './Layout.module.scss';

import { SUPPORT_BOT_LINK } from '@/lib/constants/link';

const HomeFooter = () => {
  const { sendClickEvent } = useUserEventLogger();
  const { showMessenger, openChannelTalk } = useChannelTalk();

  return (
    <footer className={'page-padding w-full bg-gray-50 pb-32 pt-16 sm:pb-20'}>
      <div className={'mx-auto w-full max-w-screen-lg pl-1'}>
        <nav className={'mb-10 space-x-4'} role="navigation" aria-label="Footer">
          <ul className="flex flex-col items-start lg:!flex-row lg:items-center lg:space-x-8">
            <MainItem link={'https://bznav.com/terms/service'} label={'통합서비스 이용약관'} clickEvent={'landing_footer_terms-service'} />
            <MainItem
              link={'https://bznav.com/popup/terms/bznav-taxrefund-service/'}
              label={'비즈넵 환급 이용약관'}
              clickEvent={'landing_footer_terms-refund'}
            />
            <MainItem link={'https://bznav.com/terms/privacy'} label={'개인정보 처리방침'} clickEvent={'landing_footer_terms-privacy'} isTextBlack />
            <MainItem
              label={'고객센터 문의'}
              clickEvent={'landing_footer_support-cx'}
              onClick={() => {
                const isPersonalTritx = sessionStorage.getItem('isPersonalTritx') === 'true';
                if (isPersonalTritx) {
                  openChannelTalk(SUPPORT_BOT_LINK.양도세환급랜딩);
                } else {
                  showMessenger();
                }
              }}
            />
          </ul>
        </nav>
        <div className="mb-12">
          <ul className={'flex w-full flex-col flex-nowrap items-start space-y-1 md:!flex-row md:flex-wrap md:items-center md:space-y-0 lg:w-11/12'}>
            <SubItem>
              <a
                href={'https://zent.kr'}
                target="_blank"
                className="font-medium text-gray-800 hover:cursor-pointer hover:underline"
                onClick={() => {
                  sendClickEvent('landing_footer_zenterprise');
                }}
                rel={'author noopener noreferrer'}
              >
                지엔터프라이즈 주식회사
              </a>
            </SubItem>
            <ItemDivider />
            <SubItem>대표&nbsp;&nbsp;이성봉</SubItem>
            <ItemDivider />
            <SubItem>사업자번호&nbsp;&nbsp;236-88-00397</SubItem>
            <ItemDivider />
            <SubItem>통신판매업신고&nbsp;&nbsp;제2016-서울강남-04379호</SubItem>
            <ItemDivider />
          </ul>
          <ul className="mt-1 flex flex-col flex-nowrap items-start space-y-1 md:mt-0 md:!flex-row md:flex-wrap md:items-center md:space-y-0">
            <SubItem>서울특별시 강남구 테헤란로 507, 9층</SubItem>
            <ItemDivider />
            <SubItem>제휴 문의&nbsp;&nbsp;contact@zent.kr</SubItem>
          </ul>
        </div>
        <div className="text-2xs text-gray-500">Copyright &copy; Z Enterprise, Inc. All rights reserved.</div>
      </div>
    </footer>
  );
};

export default HomeFooter;

const MainItem = ({
  label,
  link,
  clickEvent,
  isTextBlack = false,
  onClick
}: {
  label: string;
  link?: string;
  clickEvent: string;
  isTextBlack?: boolean;
  onClick?: () => void;
}) => {
  const { sendClickEvent } = useUserEventLogger();
  const buttonClick = () => {
    sendClickEvent(clickEvent);

    if (onClick) onClick();
  };

  const textColorCss = { 'text-black': isTextBlack, 'text-gray-600': !isTextBlack };
  return (
    <li
      className={cn('block py-2 text-sm font-medium opacity-100 transition duration-300 ease-in-out hover:cursor-pointer hover:opacity-60', textColorCss)}
      onClick={buttonClick}
    >
      {link ? (
        <Link href={link} target={'_blank'}>
          {label}
        </Link>
      ) : (
        label
      )}
    </li>
  );
};

const SubItem = ({ children }: { children: ReactNode }) => (
  <li>
    <span className="text-xs text-gray-500">{children}</span>
  </li>
);

const ItemDivider = () => <li className={`${s.divider} sr-only mx-2.5 bg-gray-300`} />;
